export default "__VITE_ASSET__2d446129__"